import { SiteDataModel, ComponentInfoModel } from '../models/site-data.model';
import { ComponentService } from '../services/component-material.service';

let componentPosition: { name: string; position: number; }[] = [];
let allComponents: ComponentInfoModel[] = [];
let isHomePage = false;

const componentService = new ComponentService();



export const loadActivatedModule = async (modules: string[], siteData: SiteDataModel, isHomePg: boolean = false) => {
  isHomePage = isHomePg;
  allComponents = [];
  componentPosition = [];
  return await asyncForeach(modules, siteData).then(() => {
    return allComponents;
  });
};

// Load all the Activated Modules into the allComponents variable
const asyncForeach = async (modules: string[], siteData: SiteDataModel) => {
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < modules.length; i++) {
    // tslint:disable-next-line:max-line-length
    if (modules[i] === 'Header') {
      allComponents.push({ name: componentService.getComponentService(modules[i]), input: {}, title: modules[i] });
      if(modules.length === 2){
        allComponents.push({ name: componentService.getComponentService('NoContent'), input: {}, title: 'NoContent' });
      }
      // tslint:disable-next-line:max-line-length
    } else if (modules[i] === 'Team' || modules[i] === 'Footer' || modules[i] === 'CtaNewsletter' || modules[i] === 'Posts') {
      allComponents.push({ name: componentService.getComponentService(modules[i]), input: siteData[modules[i]], title: modules[i] });
    } else {
      if (!siteData[modules[i]].length) {
        if (siteData[modules[i]] && (modules[i] == 'FeaturesCol' || modules[i] == 'Pricing')) {
          siteData[modules[i]] = [siteData[modules[i]]];
        }
      }
      await checkModuleExist(modules[i]).then(({ position, exist }) => {
        if (exist) {
          allComponents.push({ name: componentService.getComponentService(modules[i]), input: siteData[modules[i]][position], title: modules[i] });
        } else {
          if (!siteData[modules[i]]) {
          } else {
            allComponents.push({ name: componentService.getComponentService(modules[i]), input: siteData[modules[i]][0], title: modules[i] });
            componentPosition.push({ name: modules[i], position: 0 });
          }
        }
      });
    }
  }
};

// Check if the module is used more than once
const checkModuleExist = async (module: string) => {
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < componentPosition.length; i++) {
    if (componentPosition[i].name === module) {
      componentPosition[i].position = componentPosition[i].position + 1;
      return { position: componentPosition[i].position, exist: true };
    }
  }
  return { position: 0, exist: false };
};
